import { Fill, Stroke, Style } from 'ol/style'
import { Vector as VectorLayer } from 'ol/layer'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { all as bboxStrategy } from 'ol/loadingstrategy'
import vastmanlandJson from '../vastmanland'

const vastmanlandLayer = (map) => {
  const source = new VectorSource({
    format: new GeoJSON({
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857'
    }),
    projection: 'EPSG:3857',
    loader: function (extent, resolution, projection) {
      const features = this.getFormat().readFeatures(vastmanlandJson)
      _.each(features, feature => {
        feature.setId(feature.get('id'))
      })
      source.addFeatures(features)
      // map.getView().fit(this.getExtent())
    },
    strategy: bboxStrategy
  })
  const layer = new VectorLayer({
    className: 'vastmanlandLayer',
    zIndex: 1,
    source,
    minResolution: 300,
    style: function (feature, extent) {
      return new Style({
        stroke: new Stroke({
          color: '#ffffff',
          width: 3
        }),
        fill: new Fill({
          color: 'rgba(40,130,129,.5)'
        })
      })
    }
  })

  return layer
}

export default vastmanlandLayer
